export {
    compareBySubstring,
    sanitizeSearchString,
    stringIsEmail,
    stripDiacritics,
    validateLength,
} from "@daytrip/legacy-utils";
